<template>
  <div class="organic-container">
    <!-- Заголовки на сером фоне -->
    <div>
      
    </div>
    <!-- Общий прелоадер (показывается во время загрузки независимо от наличия данных) -->
    <div v-if="loadingChart && !isAllDataLoaded" class="text-center py-5">
      <individual-preloader :loading="true" />
    </div>

    <!-- Основной контент -->
    <div v-if="shouldShowContent">

      <!-- Карточка: График органики -->
      <div v-if="reports !== undefined && reports.length > 0" v-for="index in reports.length">
        <div v-if="reports[index - 1].loaded" class="data-section mb-4" :id="`organic-chart-${index}`">
          <div class="d-flex justify-content-between align-items-center mb-3">
              <h3 class="slice-title d-flex align-items-center">
                {{ reports[index - 1].title }}
                <tooltip :text="'<b>Средняя позиция и доля ключевых слов в ТОП</b> - диаграмма в виде кругов: Диаметр круга показывает долю попадания рекламодателя в ТОП органической выдачи. Высота расположения круга отражает среднюю позицию его объявлений на странице.'">
                  <i class="fas fa-info-circle" style="font-size: 14px; color: #6c757d; margin-left: 4px; margin-top: 5px;"></i>
                </tooltip>
              </h3>
            <download-multiselect-button v-if="reports[index - 1].items !== undefined && reports[index - 1].items.length > 0"
              :downloadReportType="downloadBubbleChart"
              :urls="downloadBubbleChartLink"
              :chartContainerSelector="`#organic-chart-${index}`"
              chartType="organic"
            />
          </div>
          <div v-if="reports[index - 1].items !== undefined && reports[index - 1].items.length > 0">
            <div class="page_title_filters d-flex flex-wrap mb-3">
              <div class="organic-bubble-chart__filter">
                <input
                  type="radio"
                  :value="'&top=3'"
                  :id="`top-three-${index}`"
                  :name="`top-three-${index}`"
                  v-model="checkedTop"
                />
                <label :for="`top-three-${index}`">Запросы в топ-3</label>
              </div>
              <div class="organic-bubble-chart__filter top-ten-thumbler">
                <input
                  type="radio"
                  :value="'&top=10'"
                  :id="`top-ten-${index}`"
                  :name="`top-ten-${index}`"
                  v-model="checkedTop"
                />
                <label :for="`top-ten-${index}`">Запросы в топ-10</label>
              </div>
            </div>

            <div class="chart-container">
              <transition name="chart-fade">
                <chart-pivot-template
                  class="organic-chart organic-bubble-chart-animation"
                  :chart-data="reports[index - 1].chartBubbleData"
                  :options="options[index - 1]"
                  :animation-type="'center'"
                  :key="`bubble-chart-organic-${index}-${bubbleLegendState.mainPeriod}-${bubbleLegendState.comparingPeriod}`"
                />
              </transition>
              <individual-preloader :loading="organicChartLoading(reports[index - 1].id)" />
            </div>

            <!-- Кастомная легенда для bubble графика органики -->
            <div class="d-flex flex-wrap bubble-container-legend w-100">
              <div class="container-legend-element" @click="toggleBubbleDataset('main')">
                <div class="bubble-legend-item" :class="{ 'legend-hidden': !bubbleLegendState.mainPeriod }">
                  <div class="bubble-circle" style="background-color: rgba(61, 70, 161, 0.5); border: 1px solid rgba(61, 70, 161, 0.5);"></div>
                  <p>Основной период</p>
                </div>
              </div>
              <div class="container-legend-element" v-if="reports[index - 1].response_comparing && reports[index - 1].response_comparing.length" @click="toggleBubbleDataset('comparing')">
                <div class="bubble-legend-item" :class="{ 'legend-hidden': !bubbleLegendState.comparingPeriod }">
                  <div class="bubble-circle" style="background-color: rgba(255, 55, 18, 0.5); border: 1px solid rgba(255, 55, 18, 0.5);"></div>
                  <p>Сравнительный период</p>
                </div>
              </div>
            </div>

            <p class="footnote">Диаметр круга: доля показов рекламодателя в топ органической выдачи</p>
          </div>
          
          <!-- Сообщение об отсутствии данных для конкретного среза -->
          <div
            v-if="reports[index - 1].items.length === 0"
            class="d-flex justify-content-center flex-wrap py-3"
          >
            <div class="error">
              <img
                :src="require(`../../../img/error.svg`)"
                alt="error"
                class="error__image__left"
              />
              За выбранный период данные отсутствуют
              <img
                :src="require(`../../../img/error.svg`)"
                alt="error"
                class="error__image__right"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Карточка: Таблица органики -->
    <div v-if="report_rows !== undefined && report_rows.length > 0" class="data-section mb-4" id="organic-table">
      <!-- Единый заголовок для всей таблицы -->
      <h3 class="section-title mb-3">
        <span v-if="report_rows.some(row => row['rows'].length > 0 && row['rows'][0] !== undefined) && reportRowsDates.length > 0">
          <span v-if="comparingValue">
            <span>{{ reportRowsTitles[0] }}</span><span>{{ reportRowsDates[0] }}</span>
          </span>
          <span v-else>
            {{ reportRowsTitles[0] + reportRowsDates[0] }}
          </span>
        </span>
        <span v-else>Статистика по ключевым словам</span>
      </h3>
      <div v-for="index in report_rows.length">
        <div
          v-if="
            (report_rows[index - 1]['rows'] !== undefined &&
              report_rows[index - 1]['rows'][0] !== undefined &&
              report_rows[index - 1]['rows'].length > 0 &&
              report_rows[index - 1]['rows'][0] !== undefined) ||
            tableThumblersHolding ||
            thumblersBubbleChart
          "
        >
          <div
            class="kw_stats__filters lower-flex d-flex flex-nowrap"
            v-if="index - 1 === thumblersNumber"
          >
            <div class="kw_stats__filter kw_stats__filter__adv lower-thumbler">
              <multiselect
                :class="{
                  active: advertisersFilter,
                  blue: true,
                }"
                v-model="advertisersFilter"
                deselect-label="✓"
                select-label=""
                selectedLabel="✓"
                :options="advertisers"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="false"
                :preserve-search="true"
                label="title"
                :searchable="false"
                track-by="id"
                :taggable="false"
                openDirection="below"
                :allowEmpty="false"
                @input="selectAdvertisersFilter"
                :disabled="false"
                :placeholder="ourPlaceholder"
              >
              </multiselect>
            </div>
            <div class="organic-bubble-chart__filter" v-if="comparingValue">
              <input
                type="checkbox"
                id="table-comparing"
                name="table-comparing"
                v-model="comparingValueTableModel"
              />
              <label for="table-comparing">По первому периоду</label>
            </div>
            <div class="kw_stats__filter__percshowup">
              <multiselect
                :class="{
                  active: filterBy,
                  blue: true,
                }"
                :value="filterBy"
                :options="filterByOptions"
                :searchable="false"
                :show-labels="false"
                label="title"
                track-by="value"
                placeholder="Сортировать по"
                :allowEmpty="false"
                @input="selectFilterBy"
                :close-on-select="true"
                :disabled="false"
              >
              </multiselect>
            </div>
            <div class="kw_stats__filter">
              <multiselect
                :value="topPersistenceFilterType"
                :options="topPersistenceFilterTypeOptions"
                :searchable="false"
                :show-labels="false"
                label="title"
                track-by="title"
                placeholder="Больше или меньше"
                :close-on-select="true"
                :allowEmpty="false"
                @input="selectTopPersistenceFilterType"
                :disabled="false"
                class="results_in_top_filter_options"
              >
              </multiselect>
            </div>
            <div class="kw_stats__filter">
              <input
                v-model="topPersistenceFilterValueModel"
                placeholder="Значение"
                type="number"
                class="form-control kw_stats__filter__value"
                :disabled="filterBy.value !== 'mean_position'"
              />
            </div>
            <div class="kw_stats__filter__apply">
              <b-button
                @click="
                  applyComparingStateModel();
                  getFieldsTable();
                  fetchKeywordsOrganicStats();
                  selectTableThumblersHolding(true);
                  selectResetStatus(true);
                  setThumblersHolding(true)
                "
                class="btn-success float-right"
                :disabled="
                  filterBy.value === 'mean_position' &&
                  topPersistenceFilterValue === '' &&
                  advertisersFilter === null
                "
              >
                Применить
              </b-button>
            </div>
            <div class="kw_stats__filter__apply" v-if="resetStatus">
              <b-button
                @click="
                  setCompetitor();
                  setReset();
                  setFieldsComparing();
                  selectAdvertisersFilter(currentAdvertiser);
                  selectTopPersistenceFilterValue(null);
                  selectOnePeriod(null);
                  fetchKeywordsOrganicStats();
                  selectTableThumblersHolding(false); //  updateOrganic(); selectAdvertisersFilter(currentAdvertiser);
                  selectFilterBy(filterByOptions[0]);
                  selectTopPersistenceFilterType({
                    title: 'Больше',
                    value: 'mean_position_gt',
                  });
                  selectTopPersistenceFilterValue('');
                  setOnlyFirstPeriodTrue();
                  selectResetStatus(false);
                  setThumblersHolding(true);
                "
                class="btn-success float-right"
              >
                Сбросить
              </b-button>
            </div>
            <download-button-new
              class="lower-download-table"
              :downloadReportType="downloadTable"
              :urls="downloadKeywordsOrganicLink"
            />
          </div>
        </div>
        <div class="overflow-auto">
          <transition name="table-fade">
            <div
              v-if="
                sliceValue === undefined || sliceValue === null || !sliceValue
              "
            >
            <results-table-organic
              class="comparing-organic-table-results"
              id="my-table"
              :fixed="true"
              :fields="fieldsTable"
              :items="report_rows[index - 1]['rows']"
              :per-page="pageItems"
              :current-page="currentPaginationPage"
              v-if="
                report_rows[index - 1]['rows'][0] !== undefined &&
                report_rows[index - 1]['rows'].length > 0 &&
                reportRowsDates[index - 1] !== undefined
              "
            />
            <b-pagination
              v-model="paginationPageModel"
              :total-rows="rowsPaginationNumber"
              :per-page="pageItems"
              aria-controls="my-table"
              :first-number="true"
              :last-number="true"
              v-if="
                report_rows[index - 1]['rows'] !== undefined &&
                report_rows[index - 1]['rows'].length > 0 &&
                report_rows[index - 1]['rows'][0] !== undefined &&
                reportRowsDates[index - 1] !== undefined
              "
            />
          </div>
          <div v-else class="table-pagination">
            <results-table-organic
              class="comparing-organic-table-results"
              id="my-table"
              :fixed="true"
              :fields="fieldsTable"
              :items="report_rows[index - 1]['rows']"
              :per-page="pageItems"
              :current-page="
                slicePaginationPage[report_rows[index - 1]['slice_param']]
              "
              v-if="
                report_rows[index - 1]['rows'][0] !== undefined &&
                report_rows[index - 1]['rows'].length > 0 &&
                reportRowsDates[index - 1] !== undefined
              "
            />
            <b-pagination
              @page-click="appleCurrentSliceType(report_rows[index - 1]['slice_param'], index - 1, $event)"
              :value="paginationPageModelSlice[report_rows[index - 1]['slice_param']]"
              :total-rows="report_rows[index - 1]['count']"
              :per-page="pageItems"
              aria-controls="my-table"
              :first-number="true"
              :last-number="true"
              v-if="
                report_rows[index - 1]['rows'] !== undefined &&
                report_rows[index - 1]['rows'].length > 0 &&
                report_rows[index - 1]['rows'][0] !== undefined &&
                reportRowsDates[index - 1] !== undefined
              "
            />
          </div>
        </transition>
        </div>
      </div>
    </div>
    <div
      v-if="
        (report_rows === undefined || report_rows.length === 0) &&
        thumblersBubbleChart
      "
    >
      <div
        v-if="thumblersBubbleChart || tableThumblersHolding || thumblersHolding"
      >
        <div class="kw_stats__filters lower-flex d-flex flex-nowrap">
          <div class="kw_stats__filter kw_stats__filter__adv lower-thumbler">
            <multiselect
              :class="{
                active: advertisersFilter,
                blue: true,
              }"
              v-model="advertisersFilter"
              deselect-label="✓"
              select-label=""
              selectedLabel="✓"
              :options="advertisers"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
              label="title"
              :searchable="false"
              track-by="id"
              :taggable="false"
              openDirection="below"
              :allowEmpty="false"
              @input="selectAdvertisersFilter"
              :disabled="false"
              :placeholder="ourPlaceholder"
            >
            </multiselect>
          </div>
          <div class="organic-bubble-chart__filter period_filter" v-if="comparingValue">
            <input
              type="checkbox"
              id="table-comparing"
              name="table-comparing"
              v-model="comparingValueTableModel"
            />
            <label for="table-comparing">По первому периоду</label>
          </div>
          <div class="kw_stats__filter__percshowup">
            <multiselect
              :class="{
                active: filterBy,
                blue: true,
              }"
              :value="filterBy"
              :options="filterByOptions"
              :searchable="false"
              :show-labels="false"
              label="title"
              track-by="value"
              placeholder="Сортировать по"
              :allowEmpty="false"
              @input="selectFilterBy"
              :close-on-select="true"
              :disabled="false"
            >
            </multiselect>
          </div>
          <div class="kw_stats__filter">
            <multiselect
              :value="topPersistenceFilterType"
              :options="topPersistenceFilterTypeOptions"
              :searchable="false"
              :show-labels="false"
              label="title"
              track-by="title"
              placeholder="Больше или меньше"
              :close-on-select="true"
              :allowEmpty="false"
              @input="selectTopPersistenceFilterType"
              :disabled="false"
              class="results_in_top_filter_options"
            >
            </multiselect>
          </div>
          <div class="kw_stats__filter">
            <input
              v-model="topPersistenceFilterValueModel"
              placeholder="Значение"
              type="number"
              class="form-control kw_stats__filter__value"
              :disabled="filterBy.value !== 'mean_position'"
            />
          </div>
          <div class="kw_stats__filter__apply">
            <b-button
              @click="
                applyComparingStateModel();
                getFieldsTable();
                fetchKeywordsOrganicStats([comparingValueTableCurrent, true]);
                selectTableThumblersHolding(true);
                selectResetStatus(true);
                setThumblersHolding(true);
              "
              class="btn-success float-right"
              :disabled="
                filterBy.value === 'mean_position' &&
                topPersistenceFilterValue === '' &&
                advertisersFilter === null
              "
            >
              Применить
            </b-button>
          </div>
          <div class="kw_stats__filter__apply" v-if="resetStatus">
            <b-button
              @click="
                setCompetitor();
                setReset();
                setFieldsComparing();
                selectAdvertisersFilter(null);
                selectTopPersistenceFilterValue(null);
                selectOnePeriod(null);
                fetchKeywordsOrganicStats();
                selectTableThumblersHolding(false); //  updateOrganic();
                selectAdvertisersFilter(currentAdvertiser);
                selectFilterBy(filterByOptions[0]);
                selectTopPersistenceFilterType({
                  title: 'Больше',
                  value: 'mean_position_gt',
                });
                selectTopPersistenceFilterValue('');
                setOnlyFirstPeriodTrue();
                selectResetStatus(false);
                setThumblersHolding(true);
              "
              class="btn-success float-right"
            >
              Сбросить
            </b-button>
          </div>
          <download-button-new
            class="lower-download-table"
            :downloadReportType="downloadTable"
            :urls="downloadKeywordsOrganicLink"
          />
        </div>
      </div>
    </div>

    <!-- Сообщение об отсутствии данных для таблиц -->
    <div v-if="showNoTableDataMessage" class="d-flex justify-content-center flex-wrap py-5">
      <div class="error">
        <img
          :src="require(`../../../img/error.svg`)"
          alt="error"
          class="error__image__left"
        />
        За выбранный период данные отсутствуют
        <img
          :src="require(`../../../img/error.svg`)"
          alt="error"
          class="error__image__right"
        />
      </div>
    </div>

    <!-- Общее сообщение об отсутствии данных -->
    <div v-if="showNoDataMessage" class="d-flex justify-content-center flex-wrap py-5">
      <div class="error">
        <img
          :src="require(`../../../img/error.svg`)"
          alt="error"
          class="error__image__left"
        />
        За выбранный период данные отсутствуют
        <img
          :src="require(`../../../img/error.svg`)"
          alt="error"
          class="error__image__right"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChartPivotTemplate from "./PivotChart";
import ResultsTableOrganic from "./TableResultsOrganic";
import Multiselect from "vue-multiselect";
import DownloadButton from "../../common/DownloadButton";
import DownloadButtonNew from "../../common/DownloadButtonNew.vue";
import DownloadMultiselectButton from "../../common/DownloadMultiselectButton";
import "../../common/chart-api";
import EventHubListenerMixin from "../../common/mixins/EventHubListener";
import {mapActions, mapGetters} from "vuex";
import Preloader from "../../common/Preloader";
import IndividualPreloader from "../../common/IndividualPreloader";
import Tooltip from "../../common/Tooltip";


function formatDateString(inputString) {
  let parts = inputString.split(" - ");
  let datePart = parts[0].split(".");
  let formattedDatePart = datePart[0] + "." + datePart[1];

  return formattedDatePart + " - " + parts[1];
}

export default {
  name: "ReportsContainerOrganic",
  components: {
    ChartPivotTemplate,
    ResultsTableOrganic,
    EventHubListenerMixin,
    Multiselect,
    DownloadButton,
    DownloadButtonNew,
    DownloadMultiselectButton,
    Preloader,
    IndividualPreloader,
    Tooltip,
  },

  data() {
    return {
      fields: [
        {
          key: "keyword_name",
          label: "Ключевое слово",
          thStyle: { width: "24%" },
        },
        { key: "ad_url_full", label: "Ссылка", thStyle: { width: "16%" } },
        {
          key: "mean_position",
          label: "Средняя позиция",
          thStyle: { width: "21%" },
        },
        { key: "in_top_3", label: "В топ-3", thStyle: { width: "16%" } },
        { key: "in_top_10", label: "В топ-10", thStyle: { width: "23%" } },
      ],
      fieldsComparing: [
        {
          key: "keyword_name",
          label: "Ключевое слово",
          thStyle: { width: "18%" },
        },
        { key: "ad_url_full", label: "Ссылка", thStyle: { width: "8%" } },
        {
          key: "mean_position",
          label: "Средняя позиция",
          thStyle: { width: "10%" },
        },
        { key: "mean_positionComparing", label: "", thStyle: { width: "10%" } },
        { key: "mean_position_delta", label: "", thStyle: { width: "10%" } },
        { key: "in_top_3", label: "В топ-3", thStyle: { width: "11%" } },
        { key: "in_top_3Comparing", label: "", thStyle: { width: "11%" } },
        { key: "in_top_10", label: "В топ-10", thStyle: { width: "11%" } },
        { key: "in_top_10Comparing", label: "", thStyle: { width: "11%" } },
      ],
      errorMessage: "",
      comparing: false,
      downloadBubbleChart: "export-organic-dashboard",
      downloadTable: "export-keywords-organic",
      dateHeaderColour: "#EBEDF3",
      chartColours: [],
      componentOrganicChartKey: false,
      dateHeaderWhite: "#FFFFFF",
      filterNumber: 10,
      reportsInitial: "",
      firstDataChartRender: "Доля в топ-3",
      sliceValue: "",
      comparingValue: "",
      comparingValueTableCurrent: null,
      thumblersFlag: true,
      thumblersNumber: 0,
      currentAdvertiser: "",
      loadingCurrentPage: false,
      componentOrganicPreloader: false,
      tableReloading: true,
      fieldsTable: [],
      onePeriodValue: null,
      currentPage: 1,
      filter: null,
      superComponent: false,
      meanPositionDownloadLink: "",
      keywordsDownloadLink: "",
      sliceType: "",
      sliceGraph: 0,
      currentSliceGraph: null,
      sliceDelta: true,
      sliceValuePast: null,
      stablePage: 0,
      // Состояние для кастомной легенды bubble графиков
      bubbleLegendState: {
        mainPeriod: true,
        comparingPeriod: true
      }
    };
  },

  updated() {
    this.getFieldsTable();
    this.setCompetitor();
    this.updateOrganic();
  },

  computed: {
    isAllDataLoaded() {
      // Проверяем, есть ли хотя бы один загруженный отчет с данными
      if (!this.reports || this.reports.length === 0) {
        return false;
      }

      // Проверяем, есть ли хотя бы один отчет с данными
      const hasLoadedData = this.reports.some(report => {
        const isLoaded = report.loaded;
        const hasItems = report.items && report.items.length > 0;

        return isLoaded && hasItems;
      });

      return hasLoadedData;
    },

    hasTableData() {
      // Проверяем, есть ли данные для таблиц
      return this.report_rows !== undefined && this.report_rows.length > 0;
    },

    showNoDataMessage() {
      // Показываем сообщение об отсутствии данных, если нет данных ни для графиков, ни для таблиц
      const hasGraphData = this.reports.length > 0 && this.reports.some(r => r.loaded && r.items !== undefined && r.items.length > 0);
      const hasTableData = this.hasTableData;

      // Показываем сообщение только если есть загруженные отчеты, но нет данных ни для графиков, ни для таблиц
      return this.reports.length > 0 && this.reports.some(r => r.loaded) && !hasGraphData && !hasTableData;
    },

    shouldShowContent() {
      // Показываем контент если есть данные для графиков ИЛИ таблиц, и нет сообщения об отсутствии данных
      return (this.isAllDataLoaded || this.hasTableData) && !this.showNoDataMessage;
    },

    showNoGraphDataMessage() {
      // Показываем сообщение об отсутствии данных для графиков, если нет данных для графиков, но есть данные для таблиц
      const hasGraphData = this.reports.length > 0 && this.reports.some(r => r.loaded && r.items !== undefined && r.items.length > 0);
      const hasTableData = this.hasTableData;

      return this.reports.length > 0 && this.reports.some(r => r.loaded) && !hasGraphData && hasTableData;
    },

    showNoTableDataMessage() {
      // Показываем сообщение об отсутствии данных для таблиц, если есть данные для графиков, но нет данных для таблиц
      const hasGraphData = this.reports.length > 0 && this.reports.some(r => r.loaded && r.items !== undefined && r.items.length > 0);
      const hasTableData = this.hasTableData;

      return this.reports.length > 0 && this.reports.some(r => r.loaded) && hasGraphData && !hasTableData;
    },

    ...mapGetters("organic_sov_dashboard", [
      "reports",
      "loadingChart",
      "getTop",
      "radiusBubbleCoef",
      "commonTitleCommon",
      "commonTitleType",
      "downloadBubbleChartLink",
      "thumblersBubbleChart",
      "organicChartLoading",
    ]),

    ...mapGetters("keywords_organic", [
      "loadingTable",
      "report_rows",
      "reportRowsTitles",
      "reportRowsDates",
      "topPersistenceFilterTypeOptions",
      "topPersistenceFilterType",
      "topPersistenceFilterValue",
      "filterBy",
      "filterByOptions",
      "onePeriod",
      "resetStatus",
      "tableThumblersHolding",
      "pageItems",
      "currentPaginationPage",
      "rowsPaginationNumber",
      "keywordsDownloadLinkWithPage",
      "keywordsDownloadComparingLinkWithPage",
      "downloadKeywordsOrganicLink",
      "comparingValueTable",
      "slicePaginationPage",
    ]),

    ...mapGetters(["competitors", "advertisers"]),

    ...mapGetters("filters", [
      "slice",
      "comparingState",
      "advertisersFilter",
      "competitorsFilter",
      "resultsPeriod",
    ]),

    formattedDate () {
      if (this.reports.length) {
        let shortDate = formatDateString(this.reports[0].date)
        return shortDate
      }
    },

    formattedDateComparing () {
      if (this.reports.length) {
        let shortDateComparing = formatDateString(this.reports[0].date_comparing)
        return shortDateComparing
      }
    },

    ourSlice() {
      return this.slice;
    },

    ourPlaceholder() {
      if (this.competitors !== undefined && this.competitors.length > 0) {
        return this.competitors[0]["title"];
      } else {
        return "Рекламодатель";
      }
    },

    currentChartLoading() {
      // Возвращаем лоадер для текущего отчета
      return this.organicChartLoading(this.reports.length > 0 ? this.reports[0].id : 0);
    },

    checkedTop: {
      get() {
        return this.getTop;
      },
      async set(v) {
        if (v === "&top=3") {
          this.firstDataChartRender = "Доля в топ-3";
        } else {
          this.firstDataChartRender = "Доля в топ-10";
        }
        this.selectTop(v);
        await this.fetchOrganicSovReports();
        await this.makeLinkedHTML();
      },
    },

    comparingValueTableModel: {
      get() {
        return this.comparingValueTable;
      },
      set(value) {
        this.selectComparingValueTable(value);
        this.onePeriodValue = this.comparingValueTable;
      },
    },

    topPersistenceFilterValueModel: {
      get() {
        return this.topPersistenceFilterValue;
      },
      set(value) {
        this.selectTopPersistenceFilterValue(value);
      },
    },

    paginationPageModel: {
      get() {
        return this.currentPaginationPage;
      },
      set(value) {
        this.applyComparingStateModel();
        this.getFieldsTable();
        this.selectCurrentPaginationPage(value);
        this.fetchKeywordsOrganicStats([this.comparingValueTableCurrent, null]);
      },
    },

    paginationPageModelSlice () {
      return this.slicePaginationPage
    },

    existsDownloadButton() {
      for (let report of this.reports) {
        if (report.items && report.items.length !== 0) {
          return true;
        }
      }
      return false;
    },

    options() {
      if (this.reportsInitial !== undefined && this.reportsInitial.length) {
        let options_arr = [];
        this.errorMessage = "";
        this.thumblersFlag = true;
        this.thumblersNumber = 0;
        let reports = this.reports;
        let firstDataChartRender = this.firstDataChartRender;
        let radiusBubbleCoef = this.radiusBubbleCoef;
        let negativeExpansion = 0;
        let positiveExpansion = 0;
        for (let report of this.reports) {
          if (report.chartBubbleData && report.chartBubbleData.datasets) {
            for (let dataset of report.chartBubbleData.datasets) {
              if (dataset.data) {
                for (let currentData of dataset.data) {
                  if ((currentData.y - currentData.r / 20) < negativeExpansion) {
                    negativeExpansion = Math.floor(currentData.y - currentData.r / 20);
                  }
                  if ((currentData.y + currentData.r / 20) > positiveExpansion) {
                    positiveExpansion = Math.ceil(currentData.y + currentData.r / 20);
                  }
                }
              }
            }
          }
        }
        this.tableRowColouring();
        for (let report_pk in this.reports) {
          if (
            this.reports[report_pk].items !== undefined &&
            this.reports[report_pk].items.length > 0 &&
            this.thumblersFlag
          ) {
            this.thumblersNumber = parseInt(report_pk);
            this.thumblersFlag = false;
          }
          if (
            reports[report_pk].response_comparing !== undefined &&
            reports[report_pk].response_comparing.length > 0
          ) {
            this.comparing = true;
          } else {
            this.comparing = false;
          }
          if (this.reports[report_pk].loaded) {
            let labels = this.reports[report_pk].labels;
            let labelsNumber = labels.length;
            let lengthData = labelsNumber;
            options_arr.push({
              scales: {
                yAxes: [
                  {
                    borderDash: [8, 8],
                    ticks: {
                      min: negativeExpansion,
                      max: positiveExpansion,
                      precision: 1,
                      stepSize: 1,
                      fontColor: "#6C757D",
                      fontSize: 12,
                      beginAtZero: true,
                      reverse: true,
                      callback: function (value) {
                        if (value >= 0) {
                          return value;
                        }
                        return "";
                      },

                    },
                    gridLines: {
                      color: "#EBEDF3",
                      display: true,
                      circular: true,
                      borderDash: [8, 8],
                      zeroLineWidth: 1,
                      zeroLineColor: "#EBEDF3",
                    },
                    scaleLabel: {
                      display: true,
                      fontSize: 14,
                      fontColor: "#6C757D",
                      fontStyle: 700,
                      fontWeight: 700,
                      labelString: "Средняя позиция",
                    },
                  },
                ],
                xAxes: [
                  {
                    ticks: {
                      fontColor: "#6C757D",
                      fontSize: 12,
                      min: 0,
                      max: labelsNumber + 1,
                      stepSize: 1,
                      beginAtZero: false,
                      callback: function (value, index, values) {
                        // index -= 1
                        if (index - 1 < lengthData && labels[index - 1]) {
                          let advertiserLabel = `${labels[index - 1]}`;
                          if (advertiserLabel) {
                            return advertiserLabel;
                          }
                        }
                        return ""; //else
                      },
                    },
                    scaleLabel: {
                      display: true,
                      fontSize: 14,
                      fontColor: "#6C757D",
                      fontStyle: 700,
                      fontWeight: 700,
                    },
                    gridLines: {
                      color: "#EBEDF3",
                      display: true,
                      circular: true,
                      borderDash: [8, 8],
                      zeroLineWidth: 0,
                    },
                  },
                ],
              },
              legend: {
                display: false,
              },

              tooltips: {
                enabled: true,
                mode: "single",
                displayColors: false,
                callbacks: {
                  label: function (tooltipItems, data) {
                    // Используем данные напрямую из tooltipItems без сложной логики
                    const datasetIndex = tooltipItems.datasetIndex;
                    const dataIndex = tooltipItems.index;

                    // Проверяем, что данные доступны
                    if (!data || !data.datasets || !data.datasets[datasetIndex] || !data.datasets[datasetIndex].data) {
                      return [];
                    }

                    // Получаем данные напрямую из текущего dataset
                    const currentData = data["datasets"][datasetIndex]["data"][dataIndex];

                    if (!currentData) {
                      return [];
                    }

                    let shareValue = currentData["result"];
                    let shareLabel = shareValue !== undefined
                      ? `${firstDataChartRender}: ${(parseFloat(shareValue) * 100).toFixed(0)}%`
                      : "";

                    let bubbleLabel = [
                      `${currentData["advertiser_title"]}`,
                      shareLabel,
                      `Ср. позиция: ${parseFloat(tooltipItems.value).toFixed(1)}`,
                    ];

                    // Определяем период по datasetIndex напрямую
                    const isComparingDataset = data["datasets"][datasetIndex]["label"].includes("(сравнение)");

                    if (isComparingDataset) {
                      const comparingDate = reports[report_pk].date_comparing;
                      if (comparingDate && comparingDate.trim() !== '') {
                        bubbleLabel.push(`Период: ${comparingDate}`);
                      } else {
                        bubbleLabel.push(`Период: ${reports[report_pk].date}`);
                      }
                    } else {
                      bubbleLabel.push(`Период: ${reports[report_pk].date}`);
                    }
                    return bubbleLabel;
                  },
                },
              },
              responsive: true,
              maintainAspectRatio: false,
              height: 200,
            });
          }
        }
        return options_arr;
      }
      return [];
    },

    myStyles() {
      return {
        responsive: true,
      };
    },

    type() {
      return { type: "line" };
    },
  },

  methods: {
    getSlice() {
      return this.slice;
    },

    async makeLinkedHTML() {
      let tables = document.getElementsByClassName("table");
      for (let tableNumber in tables) {
        let table = tables[tableNumber];
        if (table && typeof table !== "number") {
          let cells = tables[tableNumber].getElementsByTagName("td");
          for (let cellNumber in cells) {
            if (
              cells[cellNumber].textContent &&
              cells[cellNumber].textContent.includes("http")
            ) {
              let currentText = cells[cellNumber].textContent;
              cells[cellNumber].textContent = "";
              let a = document.createElement("a");
              let linkText = document.createTextNode(
                currentText
                  .replace(/^https?:\/\//, "")
                  .replace(/^http?:\/\//, "")
                  .replace("www.", "")
              );
              a.appendChild(linkText);
              a.title = currentText;
              a.href = currentText;
              cells[cellNumber].appendChild(a);
            }
          }
        } else {
          break;
        }
        await new Promise((r) => setTimeout(r, 0));
      }
    },

    async tableRowColouring() {
      let tables = document.getElementsByTagName("table");
      for (let tableNumber in tables) {
        let table = tables[tableNumber];
        if (table && typeof table !== "number") {
          let tBody = table.getElementsByTagName("tbody")[0];
          let tableRow = tBody.getElementsByTagName("tr");
          const tableHeaderRegExp =
            "\\d{2}.\\d{2}\\s+-\\s+\\d{2}.\\d{2}.\\d{4}.\\d{2}";
          for (let item = 0; item < tableRow.length; item++) {
            if (
              new RegExp(tableHeaderRegExp).test(tableRow[item].textContent)
            ) {
              tableRow[item].style.background = this.dateHeaderColour; // date headers colour
            }
          }
        } else {
          break;
        }
        await new Promise((r) => setTimeout(r, 0));
      }
    },

    async changeTableRowHeader() {
      let tables = document.getElementsByTagName("table");
      for (let tableNumber in tables) {
        let table = tables[tableNumber];
        if (table && typeof table !== "number") {
          let callIndexes = document
            .getElementsByTagName("table")
            [tableNumber].getElementsByTagName("thead")[0]
            .getElementsByTagName("tr");
          for (let callIndex in callIndexes) {
            let modifiedCallIndex = parseInt(callIndex);
            if (modifiedCallIndex === 0) {
              let firstCallIndex = callIndexes[modifiedCallIndex].querySelector(
                '[aria-colindex="3"]'
              );
              if (firstCallIndex) {
                firstCallIndex.colSpan = 2;
              }
              let secondCallIndex = callIndexes[callIndex].querySelector(
                '[aria-colindex="5"]'
              );
              if (secondCallIndex) {
                secondCallIndex.innerText = "В топ-3";
              }
              let thirdCallIndex = callIndexes[modifiedCallIndex].querySelector(
                '[aria-colindex="6"]'
              );
              if (thirdCallIndex) {
                thirdCallIndex.innerText = "";
              }
              let fourthCallIndex = callIndexes[callIndex].querySelector(
                '[aria-colindex="5"]'
              );
              if (fourthCallIndex) {
                fourthCallIndex.colSpan = 2;
              }
              let fifthCallIndex = callIndexes[callIndex].querySelector(
                '[aria-colindex="6"]'
              );
              if (fifthCallIndex) {
                fifthCallIndex.innerText = "В топ-10";
              }
              let sixthCallIndex = callIndexes[callIndex].querySelector(
                '[aria-colindex="6"]'
              );
              if (sixthCallIndex) {
                sixthCallIndex.colSpan = 2;
              }
              let seventhCallIndex = callIndexes[
                modifiedCallIndex
              ].querySelector('[aria-colindex="9"]');
              if (seventhCallIndex) {
                seventhCallIndex.remove();
              }
              let eighthCallIndex = callIndexes[
                modifiedCallIndex
              ].querySelector('[aria-colindex="8"]');
              if (eighthCallIndex) {
                eighthCallIndex.remove();
              }
              let tenthCallIndex = callIndexes[modifiedCallIndex].querySelector(
                '[aria-colindex="7"]'
              );
              if (tenthCallIndex) {
                tenthCallIndex.remove();
              }
            } else {
              break;
            }
          }
        } else {
          break;
        }
        await new Promise((r) => setTimeout(r, 0));
      }
    },

    refreshChartData() {
      this.componentOrganicChartKey = !this.componentOrganicChartKey;
    },

    reloadHoldingTableThumlersTrue() {
      if (!this.tableThumblersHolding) {
        this.tableThumblersHolding = true;
      }
    },

    reloadHoldingTableThumlersFalse() {
      if (this.tableThumblersHolding) {
        this.tableThumblersHolding = false;
      }
    },

    async updateOrganic() {
      this.sliceValue = this.slice;
      if (this.sliceValue !== this.sliceValuePast) {
        this.sliceGraph = 0;
        this.stablePage = 0;
        this.currentSliceGraph = null;
      }
      this.sliceValuePast = this.sliceValue;
      this.comparingValue = this.comparingState;
      this.reportsInitial = this.reports;
      this.setThumblersHolding(false);
      if (this.onePeriodValue === null) {
        this.onePeriodValue = this.onePeriod;
      }
      if (this.comparingValue) {
        this.fieldsTable = this.fieldsComparing;
      } else if (!this.comparingValue) {
        this.fieldsTable = this.fields;
        this.keywordsDownloadLink = this.keywordsDownloadLinkWithPage;
      } else {
        //
      }
      await this.tableRowColouring();
      await this.makeLinkedHTML();
      if (this.comparingValue) {
        await this.changeTableRowHeader();
      }
      if (this.sliceValue) {
        this.applyPaginationActiveLink();
      }
    },

    applyComparingStateModel() {
      this.comparingValueTableCurrent = this.comparingValueTable;
    },

    applyComparingStateModelNull() {
      this.comparingValueTableCurrent = null;
    },

    setCompetitor() {
      this.currentAdvertiser = this.advertisersFilter;
    },

    setReset() {
      localStorage.setItem(
        "resetProjectAdvertiser",
        JSON.stringify(this.currentAdvertiser)
      );
      sessionStorage.setItem(
        "resetProjectAdvertiser",
        JSON.stringify(this.currentAdvertiser)
      );
    },

    // Методы для управления кастомной легендой bubble графиков
    toggleBubbleDataset(period) {
      if (period === 'main') {
        this.bubbleLegendState.mainPeriod = !this.bubbleLegendState.mainPeriod;
        this.updateBubbleDatasetsVisibility();
      } else if (period === 'comparing') {
        this.bubbleLegendState.comparingPeriod = !this.bubbleLegendState.comparingPeriod;
        this.updateBubbleDatasetsVisibility();
      }
    },

    updateBubbleDatasetsVisibility() {
      // Обновляем видимость datasets для всех отчетов
      for (let report of this.reports) {
        if (report.chartBubbleData && report.chartBubbleData.datasets) {
          for (let i = 0; i < report.chartBubbleData.datasets.length; i++) {
            const dataset = report.chartBubbleData.datasets[i];
            const isComparingDataset = dataset.label && dataset.label.includes('(сравнение)');
            
            if (isComparingDataset) {
              dataset.hidden = !this.bubbleLegendState.comparingPeriod;
            } else {
              dataset.hidden = !this.bubbleLegendState.mainPeriod;
            }
          }
        }
      }
      
      // Принудительно обновляем графики
      this.$nextTick(() => {
        // Находим все canvas элементы с bubble графиками и обновляем их
        const canvasElements = document.querySelectorAll('canvas');
        canvasElements.forEach(canvas => {
          // Проверяем, что Chart доступен
          if (typeof Chart !== 'undefined' && Chart.getChart) {
            const chart = Chart.getChart(canvas);
            if (chart && chart.config.type === 'bubble') {
              chart.update();
            }
          }
        });
      });
    },

    setOnlyFirstPeriodTrue() {
      this.comparingValueTable = true;
    },

    setThumblersHolding(value) {
      this.thumblersHolding = value;
    },

    setFieldsComparing() {
      this.fieldsTable = this.fieldsComparing;
      this.selectComparingValueTable(true);
    },

    async asyncSet(asyncVal) {
      await asyncVal;
    },

    getFieldsTable() {
      if (this.comparingValue) {
        this.fieldsTable = this.fieldsComparing;
      } else if (!this.comparingValue) {
        this.fieldsTable = this.fields;
      } else "";
      this.selectOnePeriod(this.comparingValueTable);
      this.selectOnePeriodValue(this.comparingValueTable);
    },

    onFiltered() {
      this.currentPage = 1;
    },

    appleCurrentSliceType(key, value, event) {
      this.$nextTick(() => {
        this.sliceGraph = event.vueTarget.currentPage;
        this.currentSliceGraph = event.vueTarget.currentPage;
        this.sliceDelta = false;

        this.applyComparingStateModel();
        this.getFieldsTable();
        try {
          this.selectCurrentSlicePaginationPage([
            key,
            event.vueTarget.currentPage,
          ]);
        }
        catch (exceptionPage) {
          if (exceptionPage instanceof TypeError) {
            // TypeError exception occurs
          }
        }

        if (this.sliceGraph === this.currentSliceGraph) {
          this.fetchKeywordsOrganicStats([
            this.comparingValueTableCurrent,
            true,
          ]);
          this.sliceDelta = true;
        }
      })
    },

    applyPaginationActiveLink() {
      let tables = document.getElementsByClassName("table-pagination");
      for (let tableNumber in tables) {
        let table = tables[tableNumber];
        if ((table !== undefined) && table && typeof table !== "number" && typeof table !== "function") {
          let pageActiveNumberResult = table
            .getElementsByClassName("comparing-organic-table-results");
          if (pageActiveNumberResult.length !== 0) {
            let pageActiveNumber = pageActiveNumberResult[0].getAttribute("current-page");
            let ourUL = tables[tableNumber]
            .getElementsByClassName("pagination")[0]
            .getElementsByTagName("li");
            for (let liNumber in ourUL) {
              if (ourUL[liNumber].textContent === pageActiveNumber) {
                if (
                  ourUL[liNumber].classList !== undefined &&
                  !ourUL[liNumber].classList.contains("active")
                ) {
                  ourUL[liNumber].classList.add("active");
                }
              } else {
                if (
                  ourUL[liNumber].classList !== undefined &&
                  ourUL[liNumber].classList.contains("active")
                ) {
                  ourUL[liNumber].classList.remove("active");
                }
              }
              }
            }
        }
      }
    },

    ...mapActions("keywords_organic", [
      "selectFilterBy",
      "selectTopPersistenceFilterType",
      "selectTopPersistenceFilterValue",
      "selectTopPersistenceFilterTypeOptions",
      "fetchKeywordsOrganicStats",
      "selectOnePeriod",
      "selectOnePeriodValue",
      "selectResetStatus",
      "selectTableThumblersHolding",
      "selectPaginationPageNumber",
      "selectCurrentPaginationPage",
      "selectComparingValueTable",
      "selectCurrentSlicePaginationPage",
    ]),
    ...mapActions("organic_sov_dashboard", [
      "selectTop",
      "fetchOrganicSovReports",
    ]),
    ...mapActions("filters", ["selectAdvertisersFilter"]),
  },
};
</script>

<style>

</style>